import * as React from 'react';

const NotificationsCompliance: React.FC = () => {

	return (
		<span>I agree to receive security one-time passwords (OTP) and recurring work notifications via SMS and email&nbsp;*</span>
	);
};

export default React.memo(NotificationsCompliance);
